import { getFilterDefinitionByKey } from "../config/structured-search-schema";
import { useStructuredSearchStore } from "../stores";

import { cn } from "@/lib/utils";

interface FieldPillProps {
  field?: string;
  onClick?: () => void;
}

const baseClassName =
  "inline-flex h-7 shrink-0 items-center rounded-md border border-blue-200 bg-blue-50 px-2.5 text-sm font-medium text-blue-700 shadow-sm shadow-blue-100/80";

const FieldPill = ({ field, onClick }: FieldPillProps) => {
  const store = useStructuredSearchStore();
  const display = getFilterDefinitionByKey(store.schema, field)?.label ?? field ?? "";

  if (!onClick) {
    return <span className={baseClassName}>{display}</span>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        baseClassName,
        "transition-colors hover:border-blue-300 hover:bg-blue-100 focus-visible:outline-none",
      )}
    >
      {display}
    </button>
  );
};

export default FieldPill;
